import { Action } from '@ngrx/store';
import { NotificationActionTypes } from ".";
import { NotificationModel, MessageModel } from "../../model/NotificationModel";

export class ListNotificationsAction implements Action {
    public type = NotificationActionTypes.LIST;
    public data: Array<NotificationModel>;
    public item: MessageModel;
    public errorPayload: any;
    constructor(public payload: { clientId: number, userId: number }) { }
}

export class GetNotificationAction implements Action {
    public type = NotificationActionTypes.GET;
    public data: Array<NotificationModel>;
    public item: MessageModel;
    public errorPayload: any;
    constructor(public payload: { clientId: number, messageId: number }) { }
}

export class DispatchedNotificationAction implements Action {
    public type = NotificationActionTypes.DISPATCH;
    public data: Array<NotificationModel>;
    public item: MessageModel;
    public errorPayload: any;
    constructor(public payload: { id: number, notificationObject: any }) { }
}

export class RenewNotificationsAction implements Action {
    public type = NotificationActionTypes.RENEW;
    public data: Array<NotificationModel>;
    public item: MessageModel;
    public errorPayload: any;
    constructor(public payload: { clientId: number, userId: number }) { }
}

export class ClearNotificationsAction implements Action {
    public type = NotificationActionTypes.CLEAR;
    public data: Array<NotificationModel>;
    public item: MessageModel;
    public errorPayload: any;
    constructor() { }
}

export class ClearErrorsNotificationsAction implements Action {
    public type = NotificationActionTypes.CLEAR_ERRORS;
    public data: Array<NotificationModel>;
    public item: MessageModel;
    public errorPayload: any;
    constructor() { }
}

export type NotificationActions = ListNotificationsAction | GetNotificationAction | DispatchedNotificationAction | RenewNotificationsAction | ClearNotificationsAction | ClearErrorsNotificationsAction;


// WEBPACK FOOTER //
// ./src/store/action/NotificationActions.ts